import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";

const resources = {
  en: {
    translation: en,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    // Store language preference in localStorage
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "chatable-language",
      caches: ["localStorage"],
    },
  });

export default i18n;
